<!-- 由 suu 创建于 2021-08-17 星期二 -->
<template>
  <div class="detail" v-if="detailData" ref="parentScroll">
    <!-- app隐藏状态栏 自写导航栏 滑动时改变背景 -->
    <!-- v-if="isApp" -->
    <DetailNavBar
      v-if="isApp"
      :detailData="detailData"
      :opacity="navBarOpacity"
      @share="handleShare"
    ></DetailNavBar>
    <!-- 详情 -->
    <DetailDesc :detailData="detailData" :showInfo="showInfo"></DetailDesc>
    <!-- 排课 案例 提到的圈子 -->
    <!-- 滑动切换 swipeable -->
    <!-- sticky -->
    <van-tabs
      class="dt-tab"
      :class="{ 'dt-tab-one': tabArr.length < 2 }"
      v-model="tabActive"
      animated
      :swipeable="tabArr.length > 1"
      sticky
      color="#050B27"
      :line-width="100 / tabArr.length + '%'"
      line-height="1px"
      :offset-top="offsetTop"
      @change="handleTabChange"
    >
      <van-tab class="tab-item" v-for="(item, index) in tabArr" :key="index">
        <template #title>
          <span>
            {{ item }}
            <img
              class="tab-item-new"
              src="https://cdnvue.gymcity.com.cn/uploads/25coach-case-new"
              v-if="item == '会员蜕变' && caseInfo.is_new"
            />
          </span>
        </template>
        <!-- 课程时间列表 -->
        <DetailCourse
          v-show="index == 0"
          :detailData="detailData"
          :currDay="currDay"
          @appointment="handleAppointment"
        ></DetailCourse>
        <!-- 教练案例 （会员蜕变） -->
        <van-list
          v-show="tabArr[tabActive] == '会员蜕变'"
          v-model="caseLoading"
          :finished="caseFinished"
          @load="getCoachCase"
          offset="100"
        >
          <DetailCaceList
            :caseList="caseInfo.list"
            @caseClick="handleCaseClick"
          ></DetailCaceList>
          <div
            class="case-list-nomore"
            @click.stop="handleBotBtnClick('会员蜕变')"
            v-if="caseFinished"
            >这位教练看起来很棒，试试Ta的课吧<van-icon
              class="arrow-icon"
              name="arrow"
          /></div>
        </van-list>
        <!-- 教练口碑 -->
        <van-list
          v-show="tabArr[tabActive] == '口碑'"
          v-model="evaluateLoading"
          :finished="evaluateFinished"
          @load="getCoachEvaluate"
          offset="100"
        >
          <DetailEvaluateList
            :evaluateList="evaluateInfo.list"
            @tabChange="handleEvaluateTabChange"
          ></DetailEvaluateList>
          <div
            class="case-list-nomore"
            @click.stop="handleBotBtnClick('口碑')"
            v-if="evaluateFinished"
            >想了解更多？约节课体验一下<van-icon
              class="arrow-icon"
              name="arrow"
          /></div>
        </van-list>
        <!-- 圈子 -->
        <!-- <van-list
          v-if="index == 1"
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="getCoachMentionMe"
          offset="100"
        >
          <DetailCircle
            :list="circleList"
            :coachid="detailData.coachid"
          ></DetailCircle>
          <img
            v-if="finished"
            class="gray-logo"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/105e8b8098652ec924de3cec5ec06d35_wh=390_33.png"
            alt=""
          />
        </van-list> -->
      </van-tab>
    </van-tabs>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
    <!-- 约课弹窗  DetailCourse 在van-tab里弹窗fixed不能全屏幕显示 弹窗交互提出来  -->
    <!-- safe-area-inset-bottom -->
    <van-popup
      v-model="appointConfirmation"
      position="bottom"
      duration=".2"
      round
    >
      <DetailPop
        :detailData="detailData"
        :showInfo="showInfo"
        :popObj="popObj"
        @checkChange="handleCheckChange"
        @cancel="handleAppointCancel"
        @confirm="handleAppointConfirm"
      ></DetailPop>
    </van-popup>
    <!-- 超练弹窗 15-16节-->
    <van-popup v-model="showExceedTips" position="bottom" round>
      <DetailExceedPop
        :overTips="overTips"
        :vContent="vContent"
        @checkChange="handleExceedCheckChange"
        @cancel="showExceedTips = false"
        @confirm="handleAppointExceedConfirm"
      ></DetailExceedPop>
    </van-popup>
    <!-- 超练弹窗 17节及以上-->
    <DetailExceedTips
      :show="showExceedTipsMore"
      :tipsInfo="overTips"
      @close="showExceedTipsMore = false"
      @confirm="handleAppointExceedMoreConfirm"
    ></DetailExceedTips>
    <!-- 约课日期为停卡中提醒 -->
    <van-overlay :show="showTipsPop" z-index="20" height="auto">
      <DetailTipsPop
        :showTipsPopType="showTipsPopType"
        :showTipsPopMsg="showTipsPopMsg"
        @cancel="handleTipsPopCancel"
        @confirm="handleTipsPopConfirm"
      ></DetailTipsPop>
    </van-overlay>
    <!-- 生成会员案例预览大图区域 -->
    <div class="d-cases-item-poster" v-if="currentCaseItem" id="box">
      <div class="item-top">
        <div class="top-left">
          <div class="left-text">before</div>
          <img class="top-img" :src="currentCaseItem.old_img" alt="" />
        </div>
        <div class="top-right">
          <div class="right-text">after</div>
          <img class="top-img" :src="currentCaseItem.new_img" alt="" />
        </div>
      </div>
      <img
        class="poster-logo"
        src="https://cdnvue.gymcity.com.cn/uploads/pub-white-logo"
        alt=""
      />
      <img
        class="top-jt-img"
        src="https://cdnvue.gymcity.com.cn/uploads/25coach-case-jt"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import DetailDesc from './ponents/DetailDesc.vue' // 课程教练信息
import DetailCourse from './ponents/DetailCourse.vue' // 排课
// import DetailCircle from './ponents/DetailCircle.vue'
import DetailPop from './ponents/DetailPop.vue' // 约课弹窗
import DetailExceedPop from './ponents/DetailExceedPop.vue' // 超练弹窗
import DetailTipsPop from './ponents/DetailTipsPop.vue' // 停卡提醒
import DetailNavBar from './ponents/DetailNavBar.vue' // 导航栏
import ShareComponent from '@/components/app/share/share.vue' // 分享组件
import DetailCaceList from './ponents/DetailCaceList.vue' // 教练案例
import DetailEvaluateList from './ponents/DetailEvaluateList.vue' // 教练口碑
import DetailExceedTips from './ponents/DetailExceedTips.vue' // 超练弹窗
import { eventObj } from '@/components/app/share/share-method.js' // 分享组件
import dateFn from '@/common/date.js' // 日期函数
import html2canvas from 'html2canvas' // 生成图片
import { ImagePreview } from 'vant' // 图片预览
export default {
  name: 'detail',

  components: {
    DetailDesc,
    DetailCourse,
    // DetailCircle,
    DetailPop,
    DetailExceedPop,
    DetailTipsPop,
    DetailNavBar,
    ShareComponent,
    DetailCaceList,
    DetailEvaluateList,
    DetailExceedTips
  },

  props: {},

  data() {
    return {
      // 课程教练信息
      detailData: null,
      showInfo: null, // 新街口 教练擅长 新头像等信息
      offsetTop: 0,
      // 当前日期
      currDay: null,
      tabActive: 0,
      tabArr: ['私教'],
      // 教练案例
      caseInfo: {
        list: [],
        is_new: false
      },
      caseLoading: false,
      caseFinished: false,
      casePage: 1,
      casePagenum: 10,
      // 教练口碑
      evaluateInfo: {
        list: [],
        total_evaluate: ''
      },
      evaluateLoading: false,
      evaluateFinished: false,
      evaluatePage: 1,
      evaluatePagenum: 10,
      // @教练圈子
      circleList: [],
      page: 1,
      page_size: 10,
      finished: false,
      loading: false,
      // 预约确认
      appointConfirmation: false, // 显示约课确认弹窗
      popObj: null, // 约课确认弹窗信息
      checkPhoto: false,
      // 停卡提醒
      showTipsPop: false,
      showTipsPopType: 1, // 10111 停卡中 10112 停卡中 10113 预停卡 10020 未激活 其他 msg
      showTipsPopMsg: '',
      isShowFirstClassTemp: false, // 是否显示过首次约课训练提醒
      // 超练
      timer: null, // 确认按钮时长
      vContent: null, // 确认按钮内容
      vTime: 3,
      exceedCheck: false,
      isShowExceed: false, // 是否点击超练弹窗的确定
      showExceedTips: false, // 显示超练提醒弹窗 15-16节
      showExceedTipsMore: false, // 显示超练提醒弹窗 17节及以上
      exTimeStart: '', // 超练开始时间
      exObj: null, // 保存超练弹窗前课程状态
      overTips: {
        e_date: '',
        s_date: '',
        shop_name: '',
        truename: '',
        over_count: '',
        title: ''
      },
      navBarOpacity: 0,
      // 分享
      showShare: false,
      qrcodeUrl: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ],
      shareOptions: {
        //分享参数
        url: '',
        title: 'wegymer健萌',
        desc: '快来约我的课吧！',
        thumbnail: 'https://cdnvue.gymcity.com.cn/uploads/pub-logo-zfx'
      },
      curEvaluateTab: 0, // 0 默认 1 最新
      caseImgUrl: {}, // 会员案例图片
      currentCaseItem: null, // 当前会员案例
      clickBtnTimer: false, // 预约 防抖
      exConfirmTimer: false // exConfirm 防抖
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    }
  },

  watch: {},

  beforeCreate() {},

  created() {
    this.detailData = this.$store.state.subscribe.detailData
    console.log('====================================')
    console.log('detailData', this.detailData)
    console.log('====================================')
    this.currDay = this.$store.state.subscribe.currDay
    // 初始化分享
    this.initShare()
    // 获取新版教练主页信息
    this.getCoachShowInfo()
    // 获取教练案例
    this.getCoachCase()
    // 设置标题
    this.setTitle()
    this.$http.get('member/index?a=shareLogPush', {
      from: `教练主页-曝光-app`,
      from_id: 250326
    })
  },

  mounted() {
    this.$refs.parentScroll.addEventListener('scroll', this.bindScroll, {
      passive: false
    })
    this.$nextTick(() => {
      this.setTabStickyTop()
    })
  },
  beforeDestroy() {
    this.$refs.parentScroll.removeEventListener('scroll', this.bindScroll)
    clearInterval(this.timer)
  },
  destroyed() {},

  methods: {
    // 点击会员案例
    handleCaseClick(item) {
      if (this.caseImgUrl[item.id]) {
        ImagePreview({
          images: [this.caseImgUrl[item.id]],
          showIndex: false
        })
        return
      }
      this.currentCaseItem = item
      this.$toast.loading({
        message: '加载中...'
      })
      const that = this
      this.currentCaseItem = item
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.getElementById('box'), {
            backgroundColor: null,
            useCORS: true,
            scrollX: 0,
            scrollY: 0
          })
            .then(function (canvas) {
              that.$toast.clear()
              that.caseImgUrl[item.id] = canvas.toDataURL()
              setTimeout(() => {
                ImagePreview({
                  images: [that.caseImgUrl[item.id]],
                  showIndex: false
                })
              }, 200)
            })
            .catch((err) => {
              that.$toast.clear()
              that.$toast.fail('加载失败')
            })
        })
      }, 300)
    },
    // 点击底部按钮
    handleBotBtnClick(tab) {
      this.tabActive = 0
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-${tab}底部按钮点击`,
        from_id: 250326
      })
    },
    handleEvaluateTabChange(tab) {
      this.evaluatePage = 1
      this.evaluateFinished = false
      this.curEvaluateTab = tab
      this.getCoachEvaluate()
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-口碑切换排序`,
        from_id: 250326
      })
    },
    handleTabChange(index) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-点击${this.tabArr[index]}`,
        from_id: 250326
      })
    },
    // H5中设置标题
    setTitle() {
      if (!this.isApp) {
        document.title = this.detailData.name
      }
    },
    async setTabStickyTop() {
      if (this.isApp) {
        try {
          const res = await this.$betterwe.getAppBarHeight()
          if (res) {
            this.offsetTop = res.statusBarHeight + res.toolsBarHeight
          }
        } catch (error) {
          console.error('获取App栏高度失败:', error)
        }
      }
    },
    // 初始化分享
    initShare() {
      // 检查是否在 App 环境中
      if (!this.isApp) return

      // 获取环境变量并设置默认值
      const env = this.$http.getEnv()
      const baseUrlMap = {
        Pro: 'https://vue.gymcity.com.cn/?path=',
        Test: 'https://test.gymcity.com.cn/?path=',
        Default: 'http://vue.gym2.com/?path='
      }
      const baseUrl = baseUrlMap[env] || baseUrlMap.Default

      // 检查 detailData 是否存在及必要字段是否完整
      if (
        !this.detailData ||
        !this.detailData.coachid ||
        !this.detailData.name ||
        !this.detailData.shop_name ||
        !this.detailData.image
      ) {
        console.error('detailData 数据不完整，无法生成分享链接')
        return
      }

      // 构造分享链接
      const qrcodeUrl = `${baseUrl}app-appointment-trans&coachid=${this.detailData.coachid}`
      this.qrcodeUrl = qrcodeUrl

      // 设置分享选项
      this.shareOptions.title = `健萌明星同款私教-${this.detailData.name}`
      this.shareOptions.desc = `我在${this.detailData.shop_name}，和我一起行动，遇见更好的自己`
      this.shareOptions.thumbnail = `${this.detailData.image}?x-oss-process=image/resize,m_fill,h_400,w_400`
    },
    // 监听页面滑动 控制nav不透明度
    bindScroll(e) {
      let el = e.target
      let minHeight = 50
      let maxHeight = 150
      var scroll = Math.round(e.target.scrollTop)

      if (scroll < minHeight) {
        this.navBarOpacity = 0
      } else if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(pecent.toFixed(2))
      }
    },
    // 跳转卡券
    handleTipsPopConfirm() {
      this.showTipsPop = false
      if (this.showTipsPopType == 1031) {
        this.$http._toVueH5Url('cdcard', 'push', '实名认证')
      } else if (this.showTipsPopType == 29999) {
        // 处理首次约课训练提醒
        this.handleAppointConfirm()
        this.$http.get('member/index?a=shareLogPush', {
          from: `首次约课提醒-点击同意`,
          from_id: 25070211
        })
      } else if ([10115, 10119].includes(this.showTipsPopType)) {
        this.$http._toVueH5Url('online-buy-card', 'push', '在线购卡')
      } else if ([1104].includes(this.showTipsPopType)) {
        this.$http._toVueH5Url('member-grade', 'push', '会员等级')
      } else if ([10118].includes(this.showTipsPopType)) {
        // 新卡调整预激活 需要跳转我的页面  新老卡交替可以跳转我的卡券
        // 这里统一跳转我的页面
        if (this.isApp) {
          this.$betterwe.jumpRoute('/home?pageTag=4')
        } else {
          this.$toast('请在 betterwe星球App 中打开')
        }
      } else {
        this.$http._toVueH5Url('mycard', 'push', '我的卡券')
      }
    },
    handleTipsPopCancel() {
      this.showTipsPop = false
      if (this.showTipsPopType == 29999) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `首次约课提醒-点击再想想`,
          from_id: 25070211
        })
      }
    },
    handleAppointExceedMoreConfirm() {
      this.showExceedTipsMore = false
      this.handleAppointExceedConfirm(false)
    },
    // 超练弹窗确定
    handleAppointExceedConfirm(flag = true) {
      if (flag && (!this.exceedCheck || this.vContent)) return false
      // exConfirm 防抖
      if (this.exConfirmTimer) return
      this.exConfirmTimer = true

      this.showExceedTips = false
      // 保存已读超练提醒状态   （注销，每次都提醒）
      this.$http
        .get('member/index?a=setOverTips', {
          start: this.exTimeStart,
          end: dateFn.dayAfterThreeFn(0, 'now')
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.isShowExceed = true
            // 再次约课
            this.handleAppointment(this.exObj)
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
        .catch((error) => {
          this.$toast.fail('网络错误，请稍后重试')
          console.error('保存已读超练提醒状态失败:', error)
        })
        .finally(() => {
          this.exConfirmTimer = false
        })
    },
    // 超练切换勾选
    handleExceedCheckChange(exceedCheck) {
      this.exceedCheck = exceedCheck
    },
    // 拍照勾选切换
    handleCheckChange(checkPhoto) {
      this.checkPhoto = checkPhoto
    },
    // 确认预约
    // 0 常规约课、1 健萌圈-约课-热门教练 、2 健萌圈-约课-教练名片、教练健萌圈主页等、3 约课页 推荐约课默认、4 偏好推荐-推送 、5 偏好推荐-低频、取消推荐、6 教练邀请约课-教练详情、7 APP约课、8、教练代约课
    // handleAppointConfirm() {
    //   this.$toast('测试预约...')
    // },
    handleAppointConfirm() {
      if (
        location.href.indexOf('isPreTest1101') !== -1 ||
        sessionStorage.getItem('isPreTest1101')
      ) {
        this.$toast('预发布环境不支持约课')
        return
      }
      this.appointConfirmation = false
      // 处理首次约课训练提醒
      if (this.isShowFirstClassTemp) {
        this.showTipsPopType = 29999
        this.showTipsPop = true
        this.$http.get('member/index?a=shareLogPush', {
          from: `首次约课提醒-曝光`,
          from_id: 25070211
        })
        this.isShowFirstClassTemp = false // 处理完之后重置状态
        return
      }
      this.$toast.loading('预约中...')
      this.$http
        .put2('index/ordered', {
          cid: this.popObj.obj.courseid,
          is_photo: this.checkPhoto ? 1 : 0,
          order_type: 7
        })
        .then((v) => {
          this.$toast.clear()
          if (v.data.status === 200) {
            v.data.data.detail = true
            v.data.data.detailcid = this.popObj.obj.courseid
            v.data.data.detailshopname = this.popObj.shopname
            v.data.data.is_course_test = v.data.data.courseTest
            v.data.data.coachname = this.detailData.name
            v.data.data.day =
              v.data.data.info && v.data.data.s_time.split(' ')[0]
            // this.$store.commit('course', v.data.data)
            this.evaluate = {
              beforenum: v.data.data.beforenum,
              s_time: v.data.data.s_time,
              num: v.data.data.num,
              score: v.data.data.score,
              coach: v.data.data.coach,
              coachid: this.detailData.coachid,
              distance: this.popObj.distance,
              distanceP: this.popObj.distanceP,
              tages: v.data.data.tages,
              name: String(this.detailData.name),
              shop_name: String(this.detailData.shop_name),
              image: String(this.detailData.image),
              courseid: this.popObj.obj.courseid,
              e_time: this.popObj.obj.courseendtime,
              lat: this.showInfo.lat,
              lon: this.showInfo.lon
            }
            if (this.checkPhoto) {
              this.$http.post2('User/shareLog', { from: '约课-勾选拍照' })
            }
            this.$http.post2('User/shareLog', {
              from: '偏好推荐-约课成功-app'
            })
            window.appointmentCallback &&
              window.appointmentCallback.postMessage('')
            // 更新课程信息
            // this.$http.homeinfo('', '', this.$store.state.curCity.region_id)
            sessionStorage['loadHomeUpdate'] = 1
            this.$router.replace(
              '/reservations?evaluate=' + JSON.stringify(this.evaluate)
            )
            // eslint-disable-next-line
            // this.showShare = Number(v.data.data.num) >= 3 ? true : false
          } else {
            this.showTipsPopType = v.data.status
            this.showTipsPopMsg = v.data.msg
            this.showTipsPop = true
            // 预激活等操作在微信公众号进行
          }
        })
        .catch((error) => {
          this.$toast.clear()
          this.$dialog.alert({ message: '数据错误请刷新重进' })
          this.PopObj = null
          console.error('预约请求失败:', error)
        })
    },
    // 取消预约
    handleAppointCancel() {
      this.appointConfirmation = false
      this.showExceedTips = false
      this.showExceedTipsMore = false
    },
    // 调起预约确认
    async handleAppointment(obj) {
      if (obj.coursenums <= obj.left_course) return
      // clickBtn 防抖
      if (this.clickBtnTimer) return
      this.clickBtnTimer = true

      const shopname = this.detailData.shop_name
      const location = this.$store.state.location
      let lat = location?.lat || ''
      let lng = location?.lng || ''

      try {
        const res = await this.$http.get2('User/dist', {
          lat,
          lng,
          shopid: this.detailData.shopid,
          day: obj.coursestarttime.split(' ')[0],
          courseid: obj.courseid
        })
        this.clickBtnTimer = false
        this.popObj = { obj, shopname }
        if (res.data.status === 200) {
          // 测试代码
          // res.data.data.is_over_tips = 1
          // res.data.data.over_tips.over_count = 15
          // res.data.data.over_tips.risk_setting.B += '<br/>测试换行'
          // res.data.data.over_tips.risk_setting.D +=
          //   "<span style='font-weight: 600;'>测试加粗</span>"
          // 测试结束
          // 处理超练弹窗逻辑
          if (res.data.data.is_over_tips && !this.isShowExceed) {
            this._showOverTips(res.data.data.over_tips, obj)
            return
          }

          // 处理首次约课训练提醒
          if (res.data.data.is_first_class) {
            this.isShowFirstClassTemp = true
          }

          // 处理距离和时间计算
          this._calculateDistanceAndTime(res.data.data, obj)
          this.appointConfirmation = true
        }
      } catch (error) {
        console.error('预约处理出错:', error)
        this.clickBtnTimer = false
      }
    },
    _showOverTips(overTips, obj) {
      if (overTips.over_count >= 15 && overTips.over_count < 17) {
        this.timer && clearInterval(this.timer)
        this.vTime = 3
        this.vContent = `${this.vTime}s`
        this.timer = setInterval(() => {
          this.vTime--
          this.vContent = `${this.vTime}s`
          if (this.vTime <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.vContent = ''
          }
        }, 1000)
        this.showExceedTips = true
      } else {
        // 17节及以上
        this.showExceedTipsMore = true
      }
      this.exTimeStart = dateFn.dayAfterThreeFn(0, 'now')
      this.overTips = overTips
      this.exObj = obj
    },
    /**
     * 计算距离和时间并格式化文案
     * @param {Object} data - 包含距离和时间数据的对象
     * @param {number} data.dis - 距离（米）
     * @param {number} data.car_ride - 车程时间（分钟）
     * @param {number} data.human_ride - 步行时间（分钟）
     * @param {Object} obj - 课程对象
     */
    _calculateDistanceAndTime(data, obj) {
      let dis = data.dis
      if (dis < 1000000) {
        const { car_ride, human_ride } = data
        const distanceKey = dis > 1000 ? 'distance' : 'distanceP'
        const isCar = dis > 1000
        const rideTime = isCar ? car_ride : human_ride

        // 距离格式化（km）
        const distanceKm = dis / 1000
        let distanceText
        if (distanceKm < 100) {
          // 小于100km，保留1位小数
          distanceText = `${distanceKm.toFixed(1)}km`
        } else {
          // 大于等于100km，只展示整数，最高999km，超过显示+
          const intKm = Math.floor(distanceKm)
          distanceText = intKm > 999 ? '999+km' : `${intKm}km`
        }

        // 时间格式化
        let timeText
        if (rideTime <= 60) {
          // 小于等于60分钟，仅展示分钟
          timeText = `${rideTime}分钟`
        } else {
          // 大于60分钟，展示小时和分钟，最高99小时，超过显示+
          const hours = Math.floor(rideTime / 60)
          const minutes = rideTime % 60
          const displayHours = hours > 99 ? '99+' : hours
          timeText =
            minutes > 0
              ? `${displayHours}小时${minutes}分钟`
              : `${displayHours}小时`
        }

        const transportType = isCar ? '车程' : '步行'
        this.popObj[
          distanceKey
        ] = `距您${distanceText}，预计${transportType}${timeText}`
      }

      const date3 = Math.abs(
        new Date(obj.coursestarttime.replace(/-/g, '/')).getTime() - Date.now()
      )
      let days = Math.floor(date3 / (24 * 3600 * 1000)) + '天'
      let leave1 = date3 % (24 * 3600 * 1000)
      let hours = Math.floor(leave1 / (3600 * 1000)) + '小时'
      let leave2 = leave1 % (3600 * 1000)
      let minutes = Math.floor(leave2 / (60 * 1000)) + '分钟'

      if (days[0] === '0') days = ''
      this.popObj['popText'] = `${days}${hours}${minutes}`
    },
    // 取消分享
    bindCancel() {
      this.showShare = false
    },
    // 选择分享方式
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    // 调起分享
    handleShare() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-点击分享`,
        from_id: 250326
      })
      this.showShare = true
    },
    // 新版新增教练信息
    getCoachShowInfo() {
      this.$http
        .get(
          'member/index',
          {
            a: 'getCoachShowInfo',
            cid: this.detailData.coachid
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200 && res.data.data) {
            this.showInfo = res.data.data
            // 测试

            // 结束测试
            // 通过教练btwid 获取圈子
            // if (this.showInfo.btw_id) {
            //   this.getCoachMentionMe()
            // }
          }
        })
        .catch((error) => {
          console.error('获取教练信息失败:', error)
        })
    },
    // 获取@教练的圈子
    async getCoachMentionMe() {
      const TAB_TITLE = '提到Ta的'
      const TOKEN_KEY = 'autoShowCircle'

      try {
        // sessionStorage['myAppToken'] =
        //   'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MTY4NjAsInRpbWUiOjE5NDMwNzY5MjksInBob25lIjoiMTgxNjM5MTIwNzMiLCJhcmVhQ29kZSI6Ijg2IiwiY2xpZW50X3R5cGUiOjEsImxvZ2luX2lkIjowLCJpc192aXNpdG9yIjowfQ.G5X5gVWg-9plWuIHtPRp0uME1ejf0I2lD648_JZjP60'
        const token = (await this.getAppToken()) || ''
        this.loading = true

        console.log('===== 获取apptoken:', token, '=====') // 合并日志输出

        const params = {
          token,
          coach_id: this.showInfo.btw_id,
          page: this.page,
          page_size: this.page_size,
          ...(!token && { noToken: 1 }) // 使用展开运算符简化条件赋值
        }

        const res = await this.$http.getBaseApp(
          'api/v1/GymCircle/getCoachMentionMe',
          params
        )

        if (res?.data?.code === 200) {
          const { data } = res.data
          const hasData = data?.data?.length > 0

          if (hasData) {
            this.circleList = [...(this.circleList || []), ...data.data]

            if (this.page === 1) {
              this.tabArr.push(TAB_TITLE)
              if (sessionStorage[TOKEN_KEY] || !this.isApp) {
                this.$nextTick(() => {
                  this.tabActive = 1
                  sessionStorage[TOKEN_KEY] &&
                    sessionStorage.removeItem(TOKEN_KEY)
                })
              }
            }
            this.page++
          }

          this.finished = data?.current_page >= data?.last_page
        } else {
          this.finished = true
        }
      } catch (error) {
        console.error('请求异常:', error)
        this.finished = false // 保持加载能力
      } finally {
        this.loading = false
      }
    },
    getAppToken() {
      return new Promise((resolve) => {
        if (sessionStorage['myAppToken']) {
          resolve(sessionStorage['myAppToken'])
        } else if (this.isApp) {
          window.appTokenCallbackMethod = function (token) {
            if (token) {
              sessionStorage.setItem('myAppToken', token)
              resolve(token)
            }
          }
          window.getAppToken.postMessage(
            JSON.stringify({
              callbackMethod: 'appTokenCallbackMethod'
            })
          )
        } else {
          resolve('')
        }
      })
    },
    // 获取教练口碑
    getCoachEvaluate() {
      this.evaluateLoading = true
      this.$http
        .get(
          'member/Index',
          {
            a: 'getAppEvaluate',
            page: this.evaluatePage,
            pagenum: this.evaluatePagenum,
            // cid: 138481
            cid: this.detailData.coachid,
            tab: this.curEvaluateTab
          },
          true
        )
        .then((res) => {
          this.evaluateLoading = false
          // list 口碑列表 total_evaluate 智能评价
          if (res.data.code === 200 && Array.isArray(res.data.data.list)) {
            if (this.evaluatePage > 1) {
              this.evaluateInfo.list = [
                ...this.evaluateInfo.list,
                ...res.data.data.list
              ]
            } else {
              this.evaluateInfo = res.data.data
              if (this.tabArr.indexOf('口碑') === -1) {
                this.tabArr.push('口碑')
                this.$nextTick(() => {
                  // 如果不是app 且 没有切换到案例tab 则切换到口碑tab
                  if (!this.isApp && this.tabActive !== 1) {
                    this.tabActive = 1
                  }
                })
              }
            }
            this.evaluatePage++
            this.evaluateFinished =
              res.data.data.list.length < this.evaluatePagenum
            // 测试
            //
          }
        })
        .catch((err) => {
          this.evaluateLoading = false
          this.evaluateFinished = true
        })
    },
    // 获取教练案例
    getCoachCase() {
      this.caseLoading = true
      this.$http
        .get(
          'member/Index',
          {
            a: 'getAppCaseList',
            page: this.casePage,
            pagenum: this.casePagenum,
            // cid: 138481
            cid: this.detailData.coachid
          },
          true
        )
        .then((res) => {
          this.caseLoading = false
          // 测试
          // res.data.data.list = [
          //   {
          //     agree_image:
          //       'https://wegymercdn.gymcity.com.cn/member-case/f27d3a29a8d6860db7afd4bbfc4e2946.jpg',
          //     bfr_change: '0.6',
          //     cid: 15359,
          //     created_at: '2025-07-06 17:55:59',
          //     day_num: '训练8个月',
          //     id: 222,
          //     image:
          //       'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEJ0eGLpMAQVH269jrhlnI2UDS5IiaonELh65fkxF2RwegvriaAqBEJdOuJTo6U957gUKwpsdj8mqkVKa7Siay6Fz26vcH3dnvDIDOfBFwMvxnSgQ/132',
          //     img_type: 0,
          //     is_show: 1,
          //     new_bfr: '10.4',
          //     new_id: 488395,
          //     new_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_10877990705834213.png',
          //     new_weight: '59.2',
          //     old_bfr: '9.8',
          //     old_id: 408602,
          //     old_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_21659953934256226.png',
          //     old_weight: '55.1',
          //     remark: '',
          //     state: 3,
          //     target: '增肌塑形',
          //     truename: '陈涛',
          //     uid: 229243,
          //     updated_at: '2025-07-17 15:06:10',
          //     weight_change: '4.1'
          //   },
          //   {
          //     agree_image:
          //       'https://wegymercdn.gymcity.com.cn/member-case/f27d3a29a8d6860db7afd4bbfc4e2946.jpg',
          //     bfr_change: '0.6',
          //     cid: 15359,
          //     created_at: '2025-07-06 17:55:59',
          //     day_num: '训练8个月',
          //     id: 223,
          //     image:
          //       'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEJ0eGLpMAQVH269jrhlnI2UDS5IiaonELh65fkxF2RwegvriaAqBEJdOuJTo6U957gUKwpsdj8mqkVKa7Siay6Fz26vcH3dnvDIDOfBFwMvxnSgQ/132',
          //     img_type: 0,
          //     is_show: 1,
          //     new_bfr: '10.4',
          //     new_id: 488395,
          //     new_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_10877990705834213.png',
          //     new_weight: '59.2',
          //     old_bfr: '9.8',
          //     old_id: 408602,
          //     old_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_21659953934256226.png',
          //     old_weight: '55.1',
          //     remark: '',
          //     state: 3,
          //     target: '增肌塑形',
          //     truename: '陈涛',
          //     uid: 229243,
          //     updated_at: '2025-07-17 15:06:10',
          //     weight_change: '4.1'
          //   },
          //   {
          //     agree_image:
          //       'https://wegymercdn.gymcity.com.cn/member-case/f27d3a29a8d6860db7afd4bbfc4e2946.jpg',
          //     bfr_change: '0.6',
          //     cid: 15359,
          //     created_at: '2025-07-06 17:55:59',
          //     day_num: '训练8个月',
          //     id: 224,
          //     image:
          //       'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEJ0eGLpMAQVH269jrhlnI2UDS5IiaonELh65fkxF2RwegvriaAqBEJdOuJTo6U957gUKwpsdj8mqkVKa7Siay6Fz26vcH3dnvDIDOfBFwMvxnSgQ/132',
          //     img_type: 0,
          //     is_show: 1,
          //     new_bfr: '10.4',
          //     new_id: 488395,
          //     new_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_10877990705834213.png',
          //     new_weight: '59.2',
          //     old_bfr: '9.8',
          //     old_id: 408602,
          //     old_img:
          //       'https://cdnvue.gymcity.com.cn/member-case-setImg/member-case-setImg_21659953934256226.png',
          //     old_weight: '55.1',
          //     remark: '',
          //     state: 3,
          //     target: '增肌塑形',
          //     truename: '陈涛',
          //     uid: 229243,
          //     updated_at: '2025-07-17 15:06:10',
          //     weight_change: '4.1'
          //   }
          // ]
          // 测试结束
          if (res.data.code === 200 && Array.isArray(res.data.data.list)) {
            if (this.casePage > 1) {
              this.caseInfo.list = [
                ...this.caseInfo.list,
                ...res.data.data.list
              ]
            } else {
              this.caseInfo = res.data.data
              this.tabArr.push('会员蜕变')
              this.$nextTick(() => {
                if (!this.isApp) {
                  this.tabActive = 1
                }
              })
            }
            this.casePage++
            this.caseFinished = res.data.data.list.length < this.casePagenum
            // 测试
            //
          }
          // 获取教练口碑
          this.getCoachEvaluate()
        })
        .catch((err) => {
          this.caseLoading = false
          this.caseFinished = true
          // 获取教练口碑
          this.getCoachEvaluate()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.detail {
  position: fixed;
  overflow-y: scroll;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 80;
  @include flex-c;
  .dt-tab {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    // margin-top: vw(10);
    padding-bottom: vw(28);
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    // z-index: 2;
    ::v-deep {
      .van-tabs__wrap {
        padding: vw(1) vw(20);
        padding-top: vw(6);
        height: vw(50);
        box-sizing: border-box;
        background-color: #fff;
        justify-content: flex-start !important;
        .van-tabs__nav::before {
          content: '';
          width: 100%;
          height: vw(1);
          background-color: #e6e7ea;
          position: absolute;
          left: 0;
          bottom: 4vw;
        }
        .van-tabs__nav {
          // justify-content: flex-start; /* 靠左对齐 */
        }
        .van-tab {
          color: rgba($color: #050b27, $alpha: 0.8);
          font-weight: 300;
          font-size: vw(15);
          line-height: vw(21);
          // width: vw(167.5);
          // flex: none;
          // justify-content: flex-start;
          flex: 1; /* 让标签占满剩余空间 */
          .van-tab__text,
          .van-tab__text span {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tab-item-new {
            width: vw(30);
            margin-left: vw(4);
          }
        }
        .van-tab--active {
          font-weight: 600;
          color: #050b27;
        }
      }
    }
    .tab-item {
      width: 100%;
      box-sizing: border-box;
      // padding-top: vw(19);
      .case-list-nomore {
        color: rgba($color: #050b27, $alpha: 0.5);
        font-size: vw(12);
        line-height: vw(17);
        text-align: center;
        margin-top: vw(22);
      }
    }
    .d-cases {
      width: 100%;
      box-sizing: border-box;
      margin-top: 4vw;
      padding-bottom: 3vw;
      ::v-deep {
        .van-swipe {
          padding-bottom: 2vw;
        }
        .van-swipe-item {
          height: 40vw;
          // margin: 0 2.6vw;
        }
        .van-swipe__indicators {
          bottom: 0;
          .van-swipe__indicator {
            width: 1.6vw;
            height: 0.8vw;
            background-color: #cccccc;
            border-radius: 0.3vw;
          }
          .van-swipe__indicator--active {
            width: 4.3vw;
            background-color: #000;
          }
        }
      }
      .case-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .gray-logo {
      margin: 8px auto 10px;
      width: 130px;
      height: 11px;
      object-fit: contain;
    }
  }
  .dt-tab-one {
    padding-top: vw(2);
    ::v-deep {
      // tab只有课程列表一项时隐藏顶部切换
      .van-sticky,
      .van-tabs__wrap {
        // display: none;
        opacity: 0;
        height: 0;
      }
    }
  }
  .d-cases-item-poster {
    width: vw(343);
    box-sizing: border-box;
    height: fit-content;
    position: fixed;
    top: -999px;
    border-radius: 0;
    margin-bottom: 0;
    .item-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: relative;
      .top-left,
      .top-right {
        flex: 1;
        position: relative;
        .left-text,
        .right-text {
          width: vw(58);
          height: vw(22);
          background: #ff2270;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: vw(14);
          color: #ffffff;
          position: absolute;
          top: 0;
          right: 0;
        }
        .right-text {
          background: #24c789;
          right: auto;
          left: 0;
        }
        .top-img {
          width: 100%;
          height: vw(228);
          object-fit: cover;
        }
      }
      .top-user {
        width: 100%;
        box-sizing: border-box;
        height: vw(17);
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) 40%,
          rgba(0, 0, 0, 0.4) 100%
        );
        padding-right: vw(10);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: vw(9);
        color: #ffffff;
        position: absolute;
        bottom: 0;
        left: 0;
        .user-img {
          width: vw(10);
          height: vw(10);
          border-radius: 50%;
          margin-left: vw(3);
        }
        .user-name {
          margin-left: vw(2);
          margin-right: vw(3);
        }
      }
    }
    .top-jt-img {
      width: vw(66);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .poster-logo {
      width: vw(150);
      position: absolute;
      bottom: vw(10);
      right: vw(10);
    }
  }
  ::v-deep {
    .van-popup--round {
      border-radius: 8px 8px 0 0;
    }
    .van-popup-slide-bottom-leave-active {
      transition-timing-function: linear !important;
    }
    .van-popup-slide-bottom-enter-active {
      transition-timing-function: linear !important;
    }
  }
}
</style>
